/**
 * Lógica pura de skip condicional do questionário do técnico (Bloco B).
 *
 * Pergunta sem `condicionalPerguntaCodigo` é sempre visível. Com condicional,
 * só aparece se a resposta do código apontado bater com `condicionalValor`.
 *
 * Separado em arquivo `.ts` (não `.tsx`) pra não acionar warning do
 * `react-refresh/only-export-components` quando consumido junto com o
 * componente `<PerguntaTecnicoInput>`.
 */

export function isPerguntaVisivel(
  pergunta: { condicionalPerguntaCodigo?: string | null; condicionalValor?: unknown },
  respostas: Record<string, unknown>
): boolean {
  if (!pergunta.condicionalPerguntaCodigo) return true;
  const valorAtual = respostas[pergunta.condicionalPerguntaCodigo];
  if (pergunta.condicionalValor === undefined || pergunta.condicionalValor === null) {
    // Sem valor configurado, mas com código — visível se resposta existe
    return valorAtual !== undefined && valorAtual !== null && valorAtual !== '';
  }
  // Match exato (stringificado pra comparação consistente)
  return String(valorAtual) === String(pergunta.condicionalValor);
}
